var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path !== '/')?_c('topBar'):_vm._e(),(!_vm.shutdown)?_c('router-view'):_vm._e(),(_vm.loader.length)?_c('loader'):_vm._e(),(_vm.shutdown)?_c('shutdown'):_vm._e(),_c('notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }